var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opt-group" }, [
    _c("i", {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "16px",
        "margin-top": "8px",
        cursor: "pointer",
        color: "#A9AEB8",
      },
      on: { click: _vm.handleDelChildrenPort },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }